import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const activityJourneyRoutes = [
  {
    id: 'journey-activity-confirmation-flow',
    trackingName: 'Journey Activity Confirmation Flow',
    path: 'activity/confirmation/:transaction_id',
    lazy: async () => ({
      Component: (await import('../components/JourneyActivityConfirmationFlow')).JourneyActivityConfirmationFlow,
    }),
  },
  {
    id: 'journey-activity-token-category',
    trackingName: 'Journey Activity Category',
    path: 'activity/:activityType',

    lazy: async () => ({
      Component: (await import('../components/JourneyActivityTokenSubCategory')).JourneyActivityTokenSubCategory,
    }),
  },
  {
    id: 'journey-activity-token-sub-category',
    trackingName: 'Journey Activity Sub Category',
    path: 'activity/:activityType/:subToken',
    lazy: async () => ({
      Component: (await import('../components/JourneyActivityTokenSubCategory')).JourneyActivityTokenSubCategory,
    }),
  },
  {
    id: 'journey-activity-item',
    trackingName: 'Journey Activity Item',
    path: 'activity/item/:activityType/:itemToken',
    lazy: async () => ({
      Component: (await import('../components/JourneyActivityItem')).JourneyActivityItem,
    }),
    modalVariant: 'receipt',
  },
  {
    id: 'journey-activity-not-supported',
    trackingName: 'Journey Activity Not Supported',
    path: 'activity/not-supported',
    lazy: async () => ({
      Component: (await import('../components/JourneyActivityUnsupportedOpenMobileApp'))
        .JourneyActivityUnsupportedOpenMobileApp,
    }),
  },
  {
    id: 'journey-moneybot-chat',
    trackingName: 'Journey Moneybot Chat',
    path: 'moneybot/chat',
    lazy: async () => ({
      Component: (await import('../components/JourneyMoneybotChat')).JourneyMoneybotChat,
    }),
  },
  {
    id: 'journey-activity-receipt-v2',
    trackingName: 'Journey Activity Receipt V2',
    path: 'activity/receipt-v2/:encodedProto',
    lazy: async () => ({
      Component: (await import('../components/JourneyActivityReceiptV2')).JourneyActivityReceiptV2,
    }),
    modalVariant: 'receipt',
    target: 'modal',
  },
] as const satisfies JourneyRoute[]
